import { render, staticRenderFns } from "./pay_finish_index.vue?vue&type=template&id=2c70b419&scoped=true&"
import script from "./pay_finish_index.vue?vue&type=script&lang=js&"
export * from "./pay_finish_index.vue?vue&type=script&lang=js&"
import style0 from "./pay_finish_index.vue?vue&type=style&index=0&id=2c70b419&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70b419",
  null
  
)

export default component.exports